import type { IconDef } from '../types';

export const opioid: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M19 0H5C3.9 0 3 0.9 3 2V4C3 5.1 3.9 6 5 6V22C5 23.1 5.9 24 7 24H17C18.1 24 19 23.1 19 22V6C20.1 6 21 5.1 21 4V2C21 0.9 20.1 0 19 0ZM6.78 21.85L6.87 18.84H16.87L16.78 22.14L6.78 21.85ZM17.15 9.16H10.13C9.58 9.16 9.13 9.61 9.13 10.16C9.13 10.71 9.58 11.16 10.13 11.16H17.09L16.93 16.85H6.92L7.23 6.01H17.24L17.15 9.17V9.16ZM18 4H5V2H19V4H18Z',
    },
  ],
};
